import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=1933b07b"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports